import { BaseModel } from './base-model';

export class Audit extends BaseModel {
  public id?: string;
  public username?: String;
  public action?: String;
  public request?: any;
  public response?: any;
  public platform?:string;
  public type?:number;

  constructor() {
    super();
    this.id = null;
    this.username = null;
    this.action = null;
    this.request = null;
    this.response = null;
    this.platform = null;
  }
}

export enum AuditTypeEnum {
  INSERCAO,
  ATUALIZACAO,
  DELECAO,
  DOWNLOAD,
  ACESSO,
  LOGIN
}
